<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FileIdName',
})
</script>
<template>
  <div :class="bem()">
    <div :class="bem('top')">
      <div :class="bem('link')" @click.stop="$emit('detail')">{{ record?.id }}</div>
      <EyeOutlined title="预览" @click.stop="$emit('preview')" v-if="isImageFileType(record?.fileExt)" />
      <DownloadOutlined title="下载" @click.stop="$emit('download')" />
    </div>
    <div>{{ record?.fileName || '-' }}</div>
  </div>
</template>

<script lang="ts" setup name="FileIdName">
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons-vue'
import { createNamespace } from '@bd/vue3-utils'
import { isImageFileType } from '-/Common/FileDisplay'

const [_, bem] = createNamespace('FileIdName')
defineProps<{
  record?: ApiFile.Item
}>()
defineEmits<{
  (e: 'preview'): void
  (e: 'download'): void
  (e: 'detail'): void
}>()
</script>
<style lang="less">
.file-id-name {
  font-size: 14px;
  line-height: 14px;

  &__top {
    display: flex;
    gap: @margin-xs;
    align-items: center;
    margin-bottom: @margin-xs;

    .anticon {
      .active(@primary-color, @text-color-secondary);
      font-size: 14px;
      line-height: 14px;
    }
  }

  &__link {
    .active(@primary-color);
  }
}
</style>
